import {
    Card,
    CardContent,
    CardActionArea,
    CardMedia,
    Typography,
    Box,
    IconButton,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import React, { useState, useRef } from "react";
import card from './ProjectInfo/WebDevInfo';
import './Projects.css';

export default function WebDev() {
    const [scrollPosition, setScrollPosition] = useState(0);
    const containerRef = useRef(null);

    const scroll = (direction) => {
        const container = containerRef.current;
        const isMobile = window.innerWidth <= 768;
        const cardWidth = isMobile ? 280 : 270; // Adjust for mobile
        const scrollAmount = isMobile ? cardWidth : cardWidth * 2; // Scroll 1 card on mobile, 2 on desktop
        
        if (direction === 'left') {
            const newPosition = Math.max(0, scrollPosition - scrollAmount);
            setScrollPosition(newPosition);
            container.scrollTo({ left: newPosition, behavior: 'smooth' });
        } else {
            const maxScroll = container.scrollWidth - container.clientWidth;
            const newPosition = Math.min(maxScroll, scrollPosition + scrollAmount);
            setScrollPosition(newPosition);
            container.scrollTo({ left: newPosition, behavior: 'smooth' });
        }
    };

    return (
        <div>
            <Box 
                ml={{ xs: 1, sm: 3, md: 5 }} 
                mr={{ xs: 1, sm: 3, md: 5 }} 
                pl={{ xs: 2, sm: 4, md: 7 }} 
                pr={{ xs: 2, sm: 3, md: 3 }} 
                mt={3} pt={3} mb={1} pb={1}
            >
                <Box position="relative">
                    {/* Left Arrow */}
                    <IconButton
                        onClick={() => scroll('left')}
                        sx={{
                            position: 'absolute',
                            left: { xs: -15, md: -30 },
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 2,
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                            },
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            width: { xs: 35, md: 40 },
                            height: { xs: 35, md: 40 },
                        }}
                        disabled={scrollPosition === 0}
                    >
                        <ArrowBackIos />
                    </IconButton>

                    {/* Carousel Container */}
                    <Box
                        ref={containerRef}
                        sx={{
                            display: 'flex',
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            gap: { xs: 2, md: 3 },
                            paddingY: 2,
                            paddingX: { xs: 1, md: 0 },
                            scrollbarWidth: 'none', // Firefox
                            '&::-webkit-scrollbar': {
                                display: 'none', // Chrome, Safari, Edge
                            },
                            // Smooth scrolling behavior
                            scrollBehavior: 'smooth',
                            // Enable touch scrolling on mobile
                            WebkitOverflowScrolling: 'touch',
                        }}
                    >
                        {card.map((cardItem, index) => (
                            <Box
                                key={cardItem.id}
                                sx={{
                                    minWidth: { xs: '260px', sm: '240px', md: '250px' },
                                    maxWidth: { xs: '260px', sm: '240px', md: '250px' },
                                    flexShrink: 0,
                                }}
                            >
                                <CardActionArea>
                                    <Card
                                        variant="outlined"
                                        className="comCard"
                                    >
                                        <CardMedia
                                            component="img"
                                            sx={{ height: { xs: "300", sm: "400", md: "500" } }}
                                            image={cardItem.image}
                                        />
                                        <CardContent className="comContent">
                                            <Typography align="left" style={{ fontFamily: "Lilita One", fontWeight: "80", fontSize: window.innerWidth <= 768 ? "20px" : "24px", backgroundColor: "#098561", lineHeight: window.innerWidth <= 768 ? "21px" : "25px", marginBottom: "10px" }}>
                                                &nbsp;&nbsp;Project: {cardItem.title}&nbsp;&nbsp;
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: window.innerWidth <= 768 ? "16px" : "18px", lineHeight: window.innerWidth <= 768 ? "17px" : "19px", fontWeight: "500" }}>
                                                <span style={{ fontWeight: "750" }}>About:</span> {cardItem.Desc}
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: window.innerWidth <= 768 ? "16px" : "18px", marginTop: "4px", fontWeight: "500" }}>
                                                <span style={{ fontWeight: "750" }}>Stack Used:</span> {cardItem.stack}
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: window.innerWidth <= 768 ? "16px" : "18px", fontWeight: "500" }}>
                                                <a href={cardItem.Github} style={{ color: "#CB9D06" }}>Github</a>
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: window.innerWidth <= 768 ? "16px" : "18px", fontWeight: "500", marginBottom: "4px" }}>
                                                <a href={cardItem.Link} style={{ color: "#CB9D06" }}>
                                                    Link
                                                </a>
                                            </Typography>
                                            <Typography align="left" style={{ fontFamily: "Signika", fontSize: window.innerWidth <= 768 ? "16px" : "18px", lineHeight: window.innerWidth <= 768 ? "17px" : "19px", fontWeight: "500" }}>
                                                <span style={{ fontWeight: "750" }}>Mentions:</span> {cardItem.Mentions}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </CardActionArea>
                            </Box>
                        ))}
                    </Box>

                    {/* Right Arrow */}
                    <IconButton
                        onClick={() => scroll('right')}
                        sx={{
                            position: 'absolute',
                            right: { xs: -15, md: -30 },
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 2,
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 1)',
                            },
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            width: { xs: 35, md: 40 },
                            height: { xs: 35, md: 40 },
                        }}
                    >
                        <ArrowForwardIos />
                    </IconButton>
                </Box>
            </Box>
        </div>
    );
}